import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faExclamationTriangle, faLink } from "@fortawesome/pro-solid-svg-icons";
export const AccountMappingStep = ({ isAccountMapping, accountMappingError, accountMappingResult, hasPassedAccountMapping, currentStep, rowClassName, }) => {
    const getIcon = () => {
        if (currentStep === "account-mapping" && isAccountMapping) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (accountMappingError) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (hasPassedAccountMapping) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faLink });
    };
    const getRightContent = () => {
        if (currentStep === "account-mapping" && isAccountMapping) {
            return _jsx("span", { children: "Checking account mapping..." });
        }
        if (accountMappingError) {
            return _jsx("span", { children: accountMappingError });
        }
        if (accountMappingResult) {
            return (_jsxs("span", { children: [accountMappingResult.accountName || "Account", " (", accountMappingResult.wasAdded ? "Added to source" : "Verified", ")"] }));
        }
        return _jsx("span", { className: "auto-provisioning__pending-text", children: "Waiting..." });
    };
    return (_jsxs("div", { className: `auto-provisioning__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "auto-provisioning__row-left", children: [getIcon(), _jsx("span", { className: "auto-provisioning__row-label", children: "Account Mapping" })] }), _jsx("div", { className: "auto-provisioning__row-right", children: getRightContent() })] }));
};
